var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DemoIframe',_vm._b({key:_vm.$route.path,attrs:{"resource":"cameras","providerParams":{ term: _vm.$route.params.cameraId },"demoUrl":_vm.demoUrl},on:{"load-item":_vm.loadCamera}},'DemoIframe',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }